var _circle, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGradoo(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FFAA9B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0893 5.55129L13.7554 6.59503C13.4959 6.2286 13.1467 5.93872 12.7074 5.7251C12.2678 5.51175 11.7833 5.40479 11.2536 5.40479C10.4196 5.40479 9.70113 5.60619 9.09852 6.00902C8.4956 6.41184 8.0337 6.97025 7.71255 7.68426C7.39139 8.3986 7.23096 9.22558 7.23096 10.1655C7.23096 11.1054 7.39139 11.9327 7.71255 12.6467C8.0337 13.3607 8.49848 13.9195 9.10691 14.3223C9.71562 14.7251 10.4422 14.9265 11.2875 14.9265C11.8168 14.9265 12.3071 14.8195 12.758 14.6062C13.2086 14.3926 13.5411 14.1086 13.7553 13.7545V14.4485H13.7521V16.16C13.7521 16.5521 13.5772 16.7484 13.2273 16.7484H8.60767V18.5368H13.9333C14.5127 18.5368 14.9712 18.3503 15.3092 17.9776C15.647 17.605 15.8162 17.0982 15.8162 16.4577V15.0612H15.8171V5.55132L14.0893 5.55129ZM13.7018 11.6127C13.5043 12.04 13.2284 12.3725 12.8736 12.6106C12.5186 12.8487 12.1099 12.9677 11.648 12.9677C11.1859 12.9677 10.7747 12.8488 10.4141 12.6106C10.0533 12.3725 9.77442 12.04 9.57748 11.6127C9.38026 11.1854 9.28153 10.6969 9.28153 10.1476C9.28153 9.59828 9.38026 9.11013 9.57748 8.68286C9.77439 8.25555 10.0533 7.92303 10.4141 7.68493C10.7747 7.44683 11.1858 7.32793 11.648 7.32793C12.0986 7.32793 12.5043 7.44683 12.8649 7.68493C13.2254 7.92303 13.5043 8.25559 13.7018 8.68286C13.8987 9.11013 13.9974 9.59828 13.9974 10.1476C13.9974 10.6969 13.8987 11.1854 13.7018 11.6127Z",
    fill: "#0157FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradoo);
export default __webpack_public_path__ + "static/media/gradoo.e8d27153c4a5cf279505a0771ab0d1ab.svg";
export { ForwardRef as ReactComponent };